var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.667 6.7935H11.7403C10.1603 6.7935 8.87366 5.50683 8.87366 3.92683V2.00016C8.87366 1.6335 8.57366 1.3335 8.20699 1.3335H5.38033C3.32699 1.3335 1.66699 2.66683 1.66699 5.04683V10.9535C1.66699 13.3335 3.32699 14.6668 5.38033 14.6668H10.6203C12.6737 14.6668 14.3337 13.3335 14.3337 10.9535V7.46016C14.3337 7.0935 14.0337 6.7935 13.667 6.7935ZM8.18699 10.5202L6.85366 11.8535C6.80699 11.9002 6.74699 11.9402 6.68699 11.9602C6.62699 11.9868 6.56699 12.0002 6.50033 12.0002C6.43366 12.0002 6.37366 11.9868 6.31366 11.9602C6.26033 11.9402 6.20699 11.9002 6.16699 11.8602C6.16033 11.8535 6.15366 11.8535 6.15366 11.8468L4.82033 10.5135C4.62699 10.3202 4.62699 10.0002 4.82033 9.80683C5.01366 9.6135 5.33366 9.6135 5.52699 9.80683L6.00033 10.2935V7.50016C6.00033 7.22683 6.22699 7.00016 6.50033 7.00016C6.77366 7.00016 7.00033 7.22683 7.00033 7.50016V10.2935L7.48033 9.8135C7.67366 9.62016 7.99366 9.62016 8.18699 9.8135C8.38032 10.0068 8.38032 10.3268 8.18699 10.5202Z",
    fill: "#0C5EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6204 5.87317C12.2538 5.87983 13.1338 5.87983 13.8871 5.87983C14.2671 5.87983 14.4671 5.43317 14.2004 5.1665C13.2404 4.19983 11.5204 2.45983 10.5338 1.47317C10.2604 1.19983 9.78711 1.3865 9.78711 1.7665V4.09317C9.78711 5.0665 10.6138 5.87317 11.6204 5.87317Z",
    fill: "#0C5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvDownloadIcon);
export default __webpack_public_path__ + "static/media/csv-download-icon.bc15fe8fe192278ffc6a94938d7fe6d9.svg";
export { ForwardRef as ReactComponent };